/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_3_QuoteInputs */

const en_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free tier uses deterministic ATS scoring. Paid tier adds Mistral-powered tailoring with 6-dimension analysis and keyword optimization.`)
};

const de_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der kostenlose Plan nutzt deterministische ATS-Bewertung. Der Bezahlplan bringt Mistral-gestütztes Tailoring mit 6-Dimensionen-Analyse und Keyword-Optimierung.`)
};

const fr_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le forfait gratuit utilise un scoring ATS déterministe. Le forfait payant ajoute l'adaptation Mistral avec une analyse en 6 dimensions et l'optimisation des mots-clés.`)
};

const es_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan gratuito usa puntuación ATS determinista. El plan de pago añade adaptación con Mistral con análisis de 6 dimensiones y optimización de palabras clave.`)
};

const it_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il piano gratuito usa un punteggio ATS deterministico. Il piano a pagamento aggiunge la personalizzazione con Mistral, analisi a 6 dimensioni e ottimizzazione delle parole chiave.`)
};

const nl_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het gratis plan gebruikt deterministische ATS-scoring. Het betaalde plan voegt Mistral-gestuurde aanpassing toe met 6-dimensieanalyse en zoekwoordoptimalisatie.`)
};

const pl_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowy plan używa deterministycznej oceny ATS. Płatny plan dodaje dopasowywanie przez Mistral z 6-wymiarową analizą i optymalizacją słów kluczowych.`)
};

const fi_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen taso käyttää deterministista ATS-pisteytystä. Maksullinen taso lisää Mistralin räätälöinnin 6-ulotteisella analyysillä ja avainsanaoptimoinnilla.`)
};

const da_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis plan bruger deterministisk ATS-scoring. Betalt plan tilføjer Mistral-drevet tilpasning med 6-dimensionsanalyse og nøgleordsoptimering.`)
};

const sv_landing_testimonial_3_quote = /** @type {(inputs: Landing_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratisplanen använder deterministisk ATS-poängsättning. Betalplanen lägger till Mistral-driven anpassning med 6-dimensionell analys och nyckelordsoptimering.`)
};

/**
* | output |
* | --- |
* | "Free tier uses deterministic ATS scoring. Paid tier adds Mistral-powered tailoring with 6-dimension analysis and keyword optimization." |
*
* @param {Landing_Testimonial_3_QuoteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_3_quote = /** @type {((inputs?: Landing_Testimonial_3_QuoteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_3_QuoteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_3_quote(inputs)
	if (locale === "fr") return fr_landing_testimonial_3_quote(inputs)
	if (locale === "es") return es_landing_testimonial_3_quote(inputs)
	if (locale === "it") return it_landing_testimonial_3_quote(inputs)
	if (locale === "nl") return nl_landing_testimonial_3_quote(inputs)
	if (locale === "pl") return pl_landing_testimonial_3_quote(inputs)
	if (locale === "fi") return fi_landing_testimonial_3_quote(inputs)
	if (locale === "da") return da_landing_testimonial_3_quote(inputs)
	if (locale === "sv") return sv_landing_testimonial_3_quote(inputs)
	return en_landing_testimonial_3_quote(inputs)
});